import {
    Box,
    FilterPanelTrigger,
    GridSlots,
    Icons,
    Portal,
    PropsFromSlot,
    QuickFilter,
    QuickFilterControl,
} from '@thirdspacelearning/library';

const sx = {
    toolbarWrapper: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        rowGap: 2,
        columnGap: 1,
    },
    quickFilterWrapper: {
        '& .data-grid-quick-filter-control': {
            width: '200px',
        },
    },
    searchIcon: {
        color: 'gray.700.hex',
    },
    filterButtonWrapper: {
        '& button': {
            textTransform: 'none',
        },
    },
};

const DataGridToolbar = ({
    setFilterButtonEl,
    filterPanelEl,
}: PropsFromSlot<GridSlots['toolbar']>) => {
    return (
        <Portal container={filterPanelEl.current}>
            <Box sx={sx.toolbarWrapper}>
                <Box sx={sx.quickFilterWrapper}>
                    <QuickFilter debounceMs={500} defaultExpanded>
                        <QuickFilterControl
                            size="small"
                            className="data-grid-quick-filter-control"
                            placeholder="Search..."
                            slotProps={{
                                input: {
                                    startAdornment: (
                                        <Icons.Search
                                            fontSize="small"
                                            sx={sx.searchIcon}
                                        />
                                    ),
                                },
                            }}
                        />
                    </QuickFilter>
                </Box>
                <Box sx={sx.filterButtonWrapper}>
                    <FilterPanelTrigger
                        ref={setFilterButtonEl}
                        size="small"
                        startIcon={<Icons.FilterList fontSize="small" />}
                    >
                        Filters
                    </FilterPanelTrigger>
                </Box>
            </Box>
        </Portal>
    );
};

export default DataGridToolbar;
